export enum ConfigurationStatus {
  emptyData = 0,
  loadingData = 1,
  loadedData = 2,
  errorData = 3,
  nochange = 4
}

export enum TypeLogistic {
  weight = 1,
  volumetry = 3,
  fixedRate = 2
};

export enum TabManageSending {
  manage = 'manage',
  closing = 'closing'
};

export enum LogisticState {
  inSquare = 1,
  sent = 2,
  received = 3,
  delivered = 4,
  cancelled = 5
};

export enum DetailsOption {
  receive = 0,
  delivery = 1
};

export enum FeatureFlagStatus {
  success = 'success',
  error = 'error',
  failed = 'failed'
}

export enum StatusShipment {
  inPlace = 1,
  sent = 2,
  received = 3,
  delivered = 4,
  canceled = 5
}

export enum ClientStatusResponse {
  empty = 0,
  gotIt = 1,
  error = 2
}

export enum SaleTypeEnum {
  taxed = 1,
  exonerated = 2
}
